import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useOfferStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function OfferGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid />
}

export default function OfferGridLayout() {
  return <GridProvider store={useOfferStore()}>
    <OfferGrid />
  </GridProvider>
}
